'use strict';

var _ = require('lodash');
var moment = require('moment');
var MomentService = function MomentService($cacheFactory, Moment, MomentConstants) {
  var momentCache = $cacheFactory('momentService');
  function getCacheKey(instant, config) {
    return instant.toString() + ':' + config.local + ':' + config.format;
  }

  /**
   * Create a moment for the provided instant and configuration.
   *
   * @param {number|date|moment|string} instant
   * @param {*} config
   * @param {string} [stringDateFormat] - required if instant is string
   * @param {boolean} [useStrict=false] - use strict mode for parsing string date value or not
   * @param {boolean} [timezoneApplied=false] - if set to true, it is assumed that input instant already has some timezone applied
   * @returns {MomentFactory}
   */
  function of(instant, config, stringDateFormat, useStrict, timezoneApplied) {
    if (_.isNil(config)) {
      throw new Error('Invalid Moment configuration!');
    }
    if (_.isNil(instant)) {
      return undefined;
    }
    var cacheKey = getCacheKey(instant, config, timezoneApplied);
    var value = momentCache.get(cacheKey);
    if (!value) {
      value = new Moment(config, instant, stringDateFormat, useStrict, timezoneApplied);
      momentCache.put(cacheKey, value);
    }
    return value;
  }

  /**
   * Create a moment for the current time and provided configuration.
   *
   * @param {*} config
   * @returns {MomentFactory}
   */
  function now(config) {
    if (_.isNil(config)) {
      throw new Error('Invalid Moment configuration!');
    }
    return new Moment(config);
  }

  /**
   * Create a moment for the current time and provided configuration in the system-wide time zone.
   *
   * @param {*} config
   * @returns {MomentFactory}
   */
  function systemNow(config) {
    return copy(now(MomentConstants.TYPES.DATE_TIME), config);
  }

  /**
   * Create a copy of moment for the provided configuration.
   *
   * @param moment
   * @param config
   * @returns {undefined}
   */
  function copy(moment, config) {
    return moment && of(moment.value, config);
  }
  function isMoment(value) {
    return value instanceof Moment;
  }

  /**
   * Get configuration by name.
   *
   * @param {string} key
   * @returns {*} config
   */
  function getConfig(key) {
    return _.merge(MomentConstants.FIELDS, MomentConstants.TYPES)[key];
  }

  /**
   * Get format by name.
   *
   * @param {string} key
   * @returns {string} format
   */
  function getFormat(key) {
    return MomentConstants.FORMATS[key];
  }
  function ruleTypeToConfig(ruleType) {
    return MomentConstants.RULE_TYPES[ruleType];
  }

  /**
   * get twix object from moment
   * @param moment
   * @param to
   * @param params
   * @returns {Twix} twix
   */
  function twix(moment, to, params) {
    return moment.value.twix(to.value, params);
  }
  function invalidateCache() {
    momentCache.removeAll();
  }
  function isEventTimeWithinRange(eventTimeStamp, dateRange) {
    return _.isNil(eventTimeStamp) || !_.isNil(eventTimeStamp) && eventTimeStamp >= dateRange.rangeStart && eventTimeStamp <= dateRange.rangeEnd ? true : false;
  }
  function getFaresDateRange() {
    var current = moment.utc();
    var rangeStart = moment.utc(current).subtract(1, 'year').startOf('month');
    var rangeEnd = moment.utc(current).subtract(1, 'month').endOf('month');
    return {
      'rangeStart': rangeStart.valueOf(),
      'rangeEnd': rangeEnd.valueOf()
    };
  }
  return {
    TYPE: MomentConstants.TYPES,
    FIELD: MomentConstants.FIELDS,
    FORMAT: MomentConstants.FORMATS,
    TIME_USER_SETTINGS: 'TIME_USER_SETTINGS',
    DATE_USER_SETTINGS: 'DATE_USER_SETTINGS',
    DATE_TIME_USER_SETTINGS: 'DATE_TIME_USER_SETTINGS',
    USER_ACTION_DATE_TIME: 'USER_ACTION_DATE_TIME',
    of: of,
    now: now,
    systemNow: systemNow,
    copy: copy,
    isMoment: isMoment,
    getConfig: getConfig,
    getFormat: getFormat,
    ruleTypeToConfig: ruleTypeToConfig,
    twix: twix,
    invalidateCache: invalidateCache,
    isEventTimeWithinRange: isEventTimeWithinRange,
    getFaresDateRange: getFaresDateRange
  };
};
MomentService.$inject = ['$cacheFactory', 'MomentFactory', 'MomentConstants'];
module.exports = MomentService;